import styled, { css } from 'styled-components';
import { palette, key } from 'styled-theme';
import { media } from '../../../helper/styleHelper';

const fontSettings = {
  small: {
    size: key('sizes.font.tiny', '9px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.font.small', '10px'),
    spacing: '0.3px',
  },
  big: {
    size: key('sizes.font.normal', '16px'),
    spacing: '0px',
  },
};
const xxlFontSettings = {
  small: {
    size: key('sizes.xxlFont.tiny', '11px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.xxlFont.small', '12px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.xxlFont.normal', '16px'),
    spacing: '0px',
  },
};

const vxxlFontSettings = {
  small: {
    size: key('sizes.vxxlFont.tiny', '14px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.vxxlFont.small', '16px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.vxxlFont.normal', '16px'),
    spacing: '0px',
  },
};

const sizes = {
  small: '30px',
  normal: '40px',
  big: '113px',
};

const xxlSizes = {
  small: '60px',
  normal: '90px',
  big: '125px',
};

const vxxlSizes = {
  small: '60px',
  normal: '90px',
  big: '160px',
};

const colors = {
  primary: palette('white', 0),
  success: palette('success', 0),
  warning: palette('warning', 0),
  error: palette('error', 0),
  lightGreen: palette('lightGreen', 0),
};

export const StyledTextAreaField = styled.textarea`
  outline: none;
  box-sizing: border-box;
  border-radius: ${key('sizes.borderRadius.normal', '5px')};

  padding: 11px 10px;

  ${media.xxl`
    padding: ${key('sizes.gutter.small', '30px')} ${key('sizes.gutter.normal', '40px')};
  `}

  ${media.vxxl`
    padding: ${key('sizes.gutter.small', '30px')} ${key('sizes.gutter.normal', '40px')};
  `}

  ${(props) => css`
    min-height: ${sizes[props.sizevalue]};
    font-size: ${fontSettings[props.sizevalue].size};
    letter-spacing: ${fontSettings[props.sizevalue].spacing};
  `}
  ${(props) => media.xxl`
  min-height: ${xxlSizes[props.sizevalue]};
  font-size: ${xxlFontSettings[props.sizevalue].size};
  letter-spacing: ${xxlFontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.vxxl`
  min-height: ${vxxlSizes[props.sizevalue]};
  font-size: ${vxxlFontSettings[props.sizevalue].size};
  letter-spacing: ${vxxlFontSettings[props.sizevalue].spacing};
  `}
  width: 100%;

  font-family: Space Grotesk Regular;
  opacity: 1;
  border-color: ${(props) => colors[props.color]};
  background: ${palette('background', 0)};
  color: ${(props) => colors[props.color]};
  ${(props) => props.varient === 'ghost' && 'border: none;'};
  ${(props) => props.varient === 'ghost' && 'background: #F0F3F7;'};
  &:hover,
  &:focus {
    border-color: ${(props) => colors[props.color]};
    box-shadow: ${(props) =>
      props.varient === 'ghost' ? 'none' : '0 0 0 2px ' + colors[props.color]};
  }
  &::placeholder {
    font-size: ${fontSettings['big'].size};
    ${media.xxl`
      font-size: ${xxlFontSettings['big'].size};
    `}
    ${media.xxl`
      font-size: ${vxxlFontSettings['big'].size};
    `}
    color: ${(props) => colors[props.color]};
    opacity: 0.5;
  }
  resize: none;
`;
